import * as yup from 'yup';
import { brokerFirmNameValidation } from '../../fields/BrokerFirmName/BrokerFirmName.meta';
import { snapIdValidation } from '../../fields/Letter407Upload/Letter407Upload.meta';
import {
  immediateFamilyValidation,
  politicalOrganizationValidation,
} from '../../fields/PoliticallyExposed/PoliticallyExposed.meta';
import { riskToleranceValidation } from '../../fields/RiskTolerance/RiskTolerance.meta';
import { investmentExperienceValidation } from '../../fields/InvestmentExperience/InvestmentExperience.meta';
import { trustedContactInfoValidation } from '../../fields/TrustedContact/TrustedContact.meta';
import { interestedPartyValidation } from '../../fields/InterestedParty/InterestedParty.meta';
import { companySymbolsValidation } from '../../fields/ControlPerson/ControlPerson.meta';

export const validation = yup.object().shape({
  companySymbols: companySymbolsValidation,
  brokerDealerfirmName: brokerFirmNameValidation,
  snapId: snapIdValidation,
  immediateFamily: immediateFamilyValidation,
  politicalOrganization: politicalOrganizationValidation,
  riskTolerance: riskToleranceValidation,
  investmentExperience: investmentExperienceValidation,
  trustedContactInfo: trustedContactInfoValidation,
  interestedPartyInfo: interestedPartyValidation,
});
